import { TFunction } from 'i18next';
import React from 'react';
import { TagEmpty16 as TagIcon } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import { FilterOptionType, FilterSelectOption } from 'shared/types/filter';
import { FilterOptionKeys } from 'shared/types/filter-document';
import { noTagId } from 'shared/types/orderable-section';
import { Tag } from 'shared/types/tag';
import styled from 'styled-components';

const IconContainer = styled.span<{ $color: string }>`
  color: ${({ $color }) => $color ?? 'inherit'};
  line-height: 62.5%;
`;

export type Options = {
  t: TFunction;
};

export const createTagFilter = (
  tags: Tag[],
  { t }: Options,
): FilterSelectOption[] =>
  tags.length
    ? [
        {
          id: FilterOptionKeys.Tag,
          label: t('context-menus.filtering.task.filters.tags.title'),
          placeholder: t('general.labels.select'),
          icon: TagIcon,
          type: FilterOptionType.MultiSelect,
          selectOptions: [
            ...tags.map((tag) => ({
              label: tag.name,
              value: tag.id,
              start: (
                <IconContainer $color={tag.color}>
                  <Icon icon={TagIcon} />
                </IconContainer>
              ),
            })),
            {
              label: t('general.sections.tags.other.title'),
              value: noTagId,
            },
          ],
          canReset: true,
          enableSearch: true,
          optionsAsButtons: true,
        },
      ]
    : [];
